import * as React from "react";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
const HouseNumberSuffix = ({
  label,
  errorMessage,
  ...rest
}) => /* @__PURE__ */ React.createElement(
  ConnectedFormControl,
  {
    ...ConnectedFormControl.defaultProps,
    id: "additionalStreetInfo",
    "data-t": "house-number-suffix",
    label,
    errorMessage,
    ...rest
  }
);
export {
  HouseNumberSuffix as default
};
//# sourceMappingURL=HouseNumberSuffix.js.map
